module.exports = __webpack_public_path__ + "img/12.1.340edd70.jpg";